import { instalarCatalogoMotivoPadraoVuex } from './integracoes/src-next/catalogos/catalogo-motivo-padrao.vuex'
import { instalarCatalogoRegraDeCalculoVuex } from './integracoes/src-next/catalogos/catalogo-regra-de-calculo.vuex'
import { instalarCatalogoGrupoDeLocaisDeTrabalhoVuex, instalarCatalogoPerfilDePermissaoVuex, instalarCatalogoUsuarioVuex } from './integracoes/src-next/catalogos/catalogos-governanca.vuex'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {
  registrarResolvedorDeRotaLocal
} from './typescript/modulos/governanca/AssistentePontotel/apresentacao/canvas/navegacaoDaTela'
import { pinia } from './pinia'
import swal from 'sweetalert2'
import i18n, { configurarMarcaWhitelabelI18n, installI18nGlobals } from '@/typescript/servicos/i18n/i18n.servico'
import { aplicarMarcaWhitelabel } from '@/typescript/servicos/marca/marcaWhitelabel.servico'
import { FiltradorDeErrosPlugin } from 'src/erros'
import { ToastPlugin } from '@/common/toast/toastPlugin'
import servicoLocalStorage from './typescript/servicos/localStorage/localStorage.servico'
import HttpCondominio from '@/typescript/servicos/http/condominio'
import HttpFastAPI from '@/typescript/servicos/http/fastapi'
import HttpAgentePtt from '@/typescript/servicos/http/agentePtt'
import HttpControleDeEstacoes from '@/typescript/servicos/http/controleDeEstacoes'
import ServicoFlagSmith from '@/typescript/servicos/flagsmith/flagsmith.servico'

// utils
import { modalDeSucesso, modalDeErro, modalDeInformacao, modalDeConfirmacao, modalDeAlerta } from 'src/utils'

// CSS
import 'sweetalert2/dist/sweetalert2.css'

import '../static/css/general.css'
import '../static/css/transitions.css'
import '../static/css/animations.css'

import '../static/icons-antigo/style.css'

import '../static/icones/linha.css'
import '../static/icones/chapado.css'
import '../static/icones/utilitarios.css'

import '../static/css/onlyNecessaryBootstrap/bootstrap.css'
import '../static/css/variables.css'
import '@Lar21/design-tokens/lib/css/pontotel.css'
import '@Lar21/design-tokens/lib/css/sankhya.css'
import '@Lar21/design-tokens/lib/css/styles.css'
// Camada semântica fina (refinamento visual) — depois dos tokens legados/Lar21
// para o realias dos --color-* vencer na cascata.
import '../static/css/tokens-semanticos.css'
import '@Lar21/imaginii-web-components'
// Third party components
import { tooltip as pttTooltipDirective } from 'src/common/uiv/tooltip'
import { popover as pttPopoverDirective } from 'src/common/uiv/popoverDirective'
import { ModalPlugin as VModal } from 'src/common/modal/modalPlugin'
import Donut from 'vue-css-donut-chart'
import 'vue-css-donut-chart/dist/vcdonut.css'
import { Chart } from 'chart.js'
import annotationPlugin from 'chartjs-plugin-annotation'
import GoogleMapsPlugin from 'src/common/maps'
// Migration stuf
import { installDirectives } from './directives'
import PttPopover from 'src/common/uiv/PttPopover'

import Formbricks from './typescript/formbricks/formbricks'
import { installLegacyServices, registerGlobalLegacyHttpInterceptors } from './services'
import { installGlobalComponents } from 'src/common/globalCommon'
import { registerSheetLegacyHttpInterceptors } from '@/components/Sheets/Sheet/state/core'
import { registerWorkScheduleLegacyHttpInterceptors } from '@/components/WorkSchedule/state'
import { useAcessoStore } from '@next/compartilhados/acesso'
import { instalarSrcNext, prepararObservabilidade, ativarObservabilidade } from '@next/app'
import { configurarObservabilidadeLegada, normalizarErroLegado } from '@/integracoes/src-next/observabilidade'
import { obterErroOriginalLegado, projetarErroLegado } from '@/integracoes/src-next/observabilidade/erro-http-legado'
import { configuracaoObservabilidadeDoBootstrap, lerHabilitacaoErros } from '@/integracoes/src-next/observabilidade/configuracao'
import { obterIdentidadeLegada } from '@/integracoes/src-next/observabilidade/identidade'
import { criarDependenciasSrcNext } from './integracoes/src-next/criar-dependencias-src-next'
import { instalarCatalogoEmpregadorVuex } from './integracoes/src-next/catalogos/catalogo-empregador.vuex'
import { instalarCatalogoEmpregadoVuex } from './integracoes/src-next/catalogos/catalogo-empregado.vuex'
import { instalarRevalidacaoCatalogosPorImportacao } from './integracoes/src-next/catalogos/importacoes-concluidas'
import { instalarCatalogoLocalVuex } from './integracoes/src-next/catalogos/catalogo-local.vuex'
import { instalarAdaptadorSeletorLegado } from './integracoes/src-next/seletor/adaptador-seletor-legado'
import { solicitarRemocaoCacheDadosComunsLegado } from './integracoes/src-next/remover-cache-dados-comuns-legado'

Chart.register(annotationPlugin)

// O router é propriedade do boot da SPA, não de uma rota que pode desmontar.
// `state.ts` não importa `router` para não fechar o ciclo router → store →
// state; este registro único dá a ele a mesma revalidação que o handoff usa.
registrarResolvedorDeRotaLocal(rota => router.resolve(rota))

export const formbricksGlobal = new Formbricks()
export const ServicoFlagSmithGlobal = new ServicoFlagSmith(store)
export const ServicoHttpCondominio = new HttpCondominio(() => store.state)
export const ServicoHttpFastAPI = new HttpFastAPI(() => store.state)
export const ServicoHttpAgentePtt = new HttpAgentePtt(() => store.state)
export const ServicoHttpControleDeEstacoes = new HttpControleDeEstacoes(() => store.state)

configurarMarcaWhitelabelI18n(() => store.state)
document.title = aplicarMarcaWhitelabel(document.title, store.state)

/* eslint-disable  @typescript-eslint/no-explicit-any */
const swalPlugin = {
  install (app: any): void {
    const globalProperties = app.config.globalProperties
    globalProperties.$swal = swal
    globalProperties.$modalDeSucesso = modalDeSucesso
    globalProperties.$modalDeErro = modalDeErro
    globalProperties.$modalDeInformacao = modalDeInformacao
    globalProperties.$modalDeConfirmacao = modalDeConfirmacao
    globalProperties.$modalDeAlerta = modalDeAlerta
    globalProperties.$servicoLocalStorage = servicoLocalStorage
    globalProperties.$servicoHttpCondominio = ServicoHttpCondominio
  }
}
/* eslint-enable  @typescript-eslint/no-explicit-any */

const app = createApp(App)

const configuracaoObservabilidade = configuracaoObservabilidadeDoBootstrap(
  process.env.NODE_ENV,
  {
    ambiente: process.env.VUE_APP_OBSERVABILIDADE_AMBIENTE,
    dsn: process.env.VUE_APP_OBSERVABILIDADE_DSN,
    habilitado: lerHabilitacaoErros(process.env.VUE_APP_OBSERVABILIDADE_ERROS),
    release: process.env.VUE_APP_TAG_VERSION,
  },
  {
    desativado: process.env.VUE_APP_OBSERVABILIDADE_DESATIVADA === 'true',
    k8s: process.env.VUE_APP_K8s === 'true',
  },
)
const observabilidade = prepararObservabilidade(app, {
  configuracao: configuracaoObservabilidade,
  origemAplicacao: window.location.origin,
  normalizarLegado: normalizarErroLegado,
  obterErroOriginal: obterErroOriginalLegado,
  projetarErroLegado,
  obterIdentidade: () => obterIdentidadeLegada(store.state.userInfo, store.getters.usuarioEstaAutenticado === true),
})
configurarObservabilidadeLegada(observabilidade.porta)
ativarObservabilidade(app, router, observabilidade)

registerGlobalLegacyHttpInterceptors()
registerSheetLegacyHttpInterceptors()
registerWorkScheduleLegacyHttpInterceptors()

app.use(store)
app.use(pinia)
useAcessoStore(pinia).definirPerfilAtivo(store.state.perfilDeAcessoSelecionadoParaMultiPerfis)
const catalogoLocais = instalarSrcNext(app, criarDependenciasSrcNext({ store }))
instalarRevalidacaoCatalogosPorImportacao(app, catalogoLocais.contexto, store.dispatch)
app.onUnmount(instalarCatalogoLocalVuex({ store, ...catalogoLocais }))
app.onUnmount(instalarCatalogoEmpregadoVuex({ store, ...catalogoLocais, consultar: catalogoLocais.consultarEmpregados }))
app.onUnmount(instalarCatalogoEmpregadorVuex({ store, ...catalogoLocais, consultar: catalogoLocais.consultarEmpregadores }))
app.onUnmount(instalarCatalogoGrupoDeLocaisDeTrabalhoVuex({ store, ...catalogoLocais, consultar: catalogoLocais.consultarGrupos }))
app.onUnmount(instalarCatalogoPerfilDePermissaoVuex({ store, ...catalogoLocais, consultar: catalogoLocais.consultarPerfis }))
app.onUnmount(instalarCatalogoUsuarioVuex({ store, ...catalogoLocais, consultar: catalogoLocais.consultarUsuarios }))
app.onUnmount(instalarCatalogoMotivoPadraoVuex({ store, ...catalogoLocais, consultar: catalogoLocais.consultarMotivosPadrao }))
app.onUnmount(instalarCatalogoRegraDeCalculoVuex({ store, ...catalogoLocais, consultar: catalogoLocais.consultarRegrasDeCalculo }))
app.use(router)
app.use(i18n)
installI18nGlobals(app)
installGlobalComponents(app)
instalarAdaptadorSeletorLegado(app)
installDirectives(app)
installLegacyServices(app)
app.use(Donut)
app.use(GoogleMapsPlugin, {
  load: {
    key: 'AIzaSyAlUctfv8CKCv29n339XstjTu8gvmXd8lw',
    libraries: 'places'
  }
})
app.use(VModal)
app.use(swalPlugin)
app.use(FiltradorDeErrosPlugin)
app.use(ToastPlugin)
app.component('ptt-popover', PttPopover)
app.directive('ptt-popover', pttPopoverDirective)
app.directive('ptt-tooltip', pttTooltipDirective)

solicitarRemocaoCacheDadosComunsLegado()
app.mount('#app')
